import { render } from "./PaychanguBankTranferDepositWebsite.vue?vue&type=template&id=40de87ee&scoped=true"
import script from "./PaychanguBankTranferDepositWebsite.vue?vue&type=script&lang=js"
export * from "./PaychanguBankTranferDepositWebsite.vue?vue&type=script&lang=js"

import "./PaychanguBankTranferDepositWebsite.vue?vue&type=style&index=0&id=40de87ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40de87ee"]])

export default __exports__